export default {
  dataIterator: {
    rowsPerPageText: 'Items per page:',
    rowsPerPageAll: 'All',
    pageText: '{0}-{1} of {2}',
    noResultsText: 'No matching records found',
    nextPage: 'Next page',
    prevPage: 'Previous page'
  },
  dataTable: {
    rowsPerPageText: 'Rows per page:'
  },
  noDataText: 'No data available',
  carousel: {
    prev: 'Previous visual',
    next: 'Next visual'
  },
  errors: {
    codeIncorrect: 'Code is incorrect.',
    errorLogin: 'Error Logging In',
    qr: {
      notAllowed: 'ERROR: you need to grant camera access permission',
      notFound: 'ERROR: no camera on this device',
      notSupported: 'ERROR: secure context required (HTTPS, localhost)',
      notReadable: 'ERROR: is the camera already in use?',
      overConstrained: 'ERROR: installed cameras are not suitable',
      streamAPINotSupported: 'ERROR: Stream API is not supported in this browser',
      scanFailed: 'Invalid QR Code',
      tableNumberFailed: 'Invalid Table Number'
    },
    location: {
      inStoreTitle: 'Your current location is not in store',
      inStoreDescription: 'You cannot place a dine-in order, please select Pickup or Delivery',
      inStoreBtn: 'Accept',
      locationDisabledTitle: 'Please allow GPS location',
      locationDescription: 'Please scan QR Code again, and allow GPS location, or enable directly from your phone settings',
      locationBtn: 'Accept'
    },
    cart: {
      menuUnavailable: 'Menu is unavailable during these hours',
      startShopping: 'Start Ordering'
    },
    schedule: {
      availableTimes: '{0} is only available from {1} - {2}',
      unavailableTimes: '{0} is not available from {1} - {2}',
      availableDay: '{0} will be available {1} at {2}',
      unavailable: '{0} is not currently available. Try another order type',
      startScheduling: 'You can start scheduling orders {0} at {1}'
    },
    paymentUnsuccessful: 'Payment Unsuccessful',
    temporarilyAppear: 'This charge may temporarily appear on your statement before being removed',
    pageNotFound: 'Page Not Found',
    storeNotFoundMessage: 'The store you are looking for could not be found. It may have been moved, deleted, or the URL may be incorrect.'
  },
  common: {
    storeHoursClosedHoliday: "Closed",
    today: 'Today',
    nextAvailable: 'Next available',
    referralButtonText: 'Invite Your Friends',
    pointsEarned: 'Points earned',
    confirmTitle: 'Please Confirm',
    confirmDesc: 'Are you sure you want to switch from Dine-in ordering?',
    actionText: 'Yes, switch',
    pickup: 'Pickup',
    delivery: 'Delivery',
    availableToDeliver: 'Available to Deliver',
    notAvailableForDelivery: 'Not Available for Delivery',
    loginDescription: 'Sign up or log in now to unlock exclusive coupons, rewards, and personalized offers tailored just for you!',
    orderNow: 'Order Now',
    hours: 'Hours',
    location: 'Location',
    contact: 'Contact',
    socials: 'Socials',
    snappyWhy: 'Why Snappy',
    snappyBlog: 'Blog',
    snappyPricing: 'Pricing',
    snappyDemo: 'Book a Demo',
    snappyCaseStudies: 'Case Studies',
    clickToRedeem: 'Click to redeem',
    apply: 'Apply',
    order: 'Order',
    sortByDistance: 'Sort by distance',
    sortByAlpha: 'Sort Alphabetically',
    searchLocations: 'Search locations',
    az: 'A-Z',
    nearest: 'Nearest',
    atLeast: 'At least',
    to: 'to',
    takeout: 'Takeout',
    or: 'or',
    guest: 'Guest',
    back: 'Back',
    other: 'Other',
    groups: 'Groups',
    options: 'Options',
    edit: 'Edit',
    register: 'Register',
    poweredBy: 'POWERED BY',
    firstName: 'First Name',
    lastName: 'Last Name',
    phone: 'Phone',
    phoneNumber: 'Phone Number',
    address: 'Address',
    storeHours: 'Store Hours',
    onlineOrderAvailableUntil: 'Online Order Available Until',
    mobileNumber: 'Mobile Number',
    status: 'Status',
    points: 'Points',
    balance: 'Balance',
    save: 'Save',
    changesSaved: 'Changes Saved',
    cancel: 'Cancel',
    confirm: 'Confirm',
    message: 'Message',
    loadMore: 'Load More',
    loading: 'Loading...',
    expires: 'Expires',
    login: 'Login / Sign Up',
    tweet: 'Tweet',
    share: 'Share',
    resend: '(Send Again in: {0})',
    newCode: 'New Code',
    logout: 'Logout',
    fillFields: 'Please fill in all required fields',
    invalidEmail: 'E-mail is invalid',
    verify: '6 Digital Code',
    continue: 'Continue',
    verifyCode: 'Verify Code',
    sixDigitCode: '6 Digit Code',
    unlimited: 'Unlimited',
    upTo: 'up to',
    selected: 'selected',
    items: 'items',
    amount: 'Amount',
    scanQRCode: 'Scan Dine-In QR Code',
    loadingQRScanner: 'Loading Scanner...',
    reloadQRScanner: 'Reload',
    open: 'Open',
    open2: 'Open',
    closed: 'Closed',
    closed2: 'Closed',
    email: 'E-Mail',
    select: 'Select',
    ok: "Ok",
    okConfirm: "Ok",
    off: 'OFF',
    app: {
      text1: 'Open In',
      text2: 'App',
      btn: 'Open'
    },
    captcha: {
      main: 'This site is protected by reCAPTCHA and the Google\'s',
      privacy: 'Privacy Policy',
      and: 'and',
      terms: 'Terms of Service',
      apply: 'apply.'
    },
    disclaimer: {
      main: 'By logging in, I agree to the <link-tos>Terms of Service</link-tos> & <link-pp>Privacy Policy</link-pp>.  I consent to receive SMS messages and other digital communications, including coupons, special offers, and promotions from {businessName}. Standard message and data rates may apply.',
      register: 'By clicking REGISTER you agree to Snappy\'s <link-tos>Terms of Service</link-tos> & <link-pp>Privacy Policy</link-pp>. Snappy will use SMS info to secure your account and send notifications. You may opt out of SMS messages at any time.'
    },
    addedToCart: 'Added "{0}" to cart',
    yourOrderId: 'Your Order ID is'
  },
  hours: {
    twentyFourHours: 'Open 24 Hours',
    midNight: 'Midnight',
    mon: "Mon",
    tues: "Tue",
    wed: "Wed",
    thurs: "Thu",
    fri: "Fri",
    sat: "Sat",
    sun: "Sun",
    monday: "Mon",
    tuesday: "Tue",
    wednesday: "Wed",
    thursday: "Thu",
    friday: "Fri",
    saturday: "Sat",
    sunday: "Sun"
  },
  menu: {
    specialRequests: 'Special Instructions',
    required: 'REQUIRED',
    optional: 'OPTIONAL',
    soldOut: 'Sold out',
    selectMenu: 'Please select a menu',
    menuTitle: 'Menu',
    promotionsAndRewards: 'Promotion & Rewards',
    categories: 'Categories',
    noMenu:  'No menu found in store',
    dropdown: 'Menu Dropdown',
    unavailable: 'Menu unavailable',
    available: 'Hours available',
    dayAvailable: 'Next available',
    availableOffHours: 'This menu is available for scheduled orders',
    menuIsExclusive: 'Items from different menu can not be added to the same cart',
    item: {
      onlyAvailable: 'Available',
      available: 'This item is only available from {0} - {1}',
      prepTime: 'This item usually takes about {0} to prepare'
    },
    menuAvailability: 'Menu Availability',
    gotIt: 'Got it!',
    onlyAvailable: 'This menu is only available during specific hours:',
    pricingBanner: 'Order directly from {2} and save up to {0}% on average compared to {1}'
  },
  cart: {
    title: 'Cart',
    startShopping: 'Start Ordering',
    continue: 'Continue',
    serviceFee: 'Service Fee',
    takeOutOrder: 'TAKEOUT ORDER',
    backToLogin: 'Back to Login',
    enterYourAddress: 'Delivery Address',
    startAdding: 'Start adding items from the menu to build your order.',
    buildOrder: "Add new items to continue building your order",
    currentlyClosed: ' is currently closed. Please come back during appropriate hours.',
    delivery: 'Delivery',
    pickup: 'Pickup',
    dinein: 'Dine-in',
    estTimeHours: 'hours',
    estTimeMins: 'mins',
    subtotal: 'Subtotal',
    deliveryFee: 'Delivery Fee',
    tbd: 'TBD',
    deliveryMinimum: 'Minimum for Delivery',
    pickupMinimum: 'Minimum for Pickup',
    tax: 'Tax',
    tip: 'Tip',
    tipDriver: 'Tip the Driver',
    tipStore: 'Support the store by tipping',
    rewards: 'Rewards',
    total: 'Total',
    btnCheckout: 'Checkout',
    addToCart: 'Add To Cart',
    aiRecommendationsTitle: 'Recommended For You',
    aiRecommendationsTitleGuest: 'Recommended',
    aiRecommendationsSubtitle: 'Based on your orders',
    aiRecommendationsSubtitleGuest: 'Popular at this store',
    aiRecommendationsFrom: 'From',
    saveCartItem: 'Update Cart',
    clickToSee: 'Click to see options',
    payWithMembership: 'Pay with Membership',
    btnSubmitSubOrder: 'Submit Order',
    processing: 'Processing your order',
    pastOrders: 'Past Orders',
    discount: 'Discount',
    btnPayOrder: 'Submit Order',
    closeModal: 'Close',
    cartUnavailable: 'There are items in your cart which cannot be ordered due to conflicting or invalid availability',
    storeUnavailable: 'Currently unavailable',
    storeClosedBtn: 'Store Closed',
    offHourOrderingMaybeAllowed: 'Store is currently closed. However, you may still schedule an order for a later time.',
    advanceBookingWindow: 'Store is open but not yet accepting orders. You may schedule an order for a later time.',
    deliveryUnavailable: 'Delivery is currently unavailable',
    pickupUnavailable: 'Pickup is currently unavailable',
    tooSmallForDelivery: 'Order amount too small for Delivery (Min: {0})',
    tooSmallForPickup: 'Order amount too small for Pickup (Min: {0})',
    invalidCoupon: 'Invalid Coupon',
    cartErrors: 'Cart Errors',
    removeInvalidItemToContinue: 'Please remove it to continue.',
    discountNotUsed: 'The cart must not be empty',
    deliveryDisabled: 'Delivery is temporarily disabled by the merchant',
    pickupDisabled: 'Pickup is temporarily disabled by the merchant',
    deliveryDisabledUntil: 'Delivery is temporarily disabled by<br>the merchant until {0}',
    pickupDisabledUntil: 'Pickup is temporarily disabled by<br>the merchant until {0}',
    asapClosed: 'Closed · Opens {0} at {1}',
    asapPastCutoff: 'No longer accepting orders for today',
    asapSuspendedToday: 'No longer accepting orders for today',
    storeStoppedAcceptingOrders: 'The store stopped accepting orders while you were checking out. Choose a scheduled time to continue.',
  },
  account: {
    accountInfo: 'Account Info',
    orderHistory: 'Order History',
    paymentMethods: 'Payment Methods',
    contactInfo: 'Contact Information',
    membershipInfo: 'Membership Information',
    member: 'Member',
    nonMember: 'Non-Member',
    creditCard: 'Credit Card',
    nameOnCard: 'Name On Card',
    cardNumber: 'Card Number',
    expires: 'Expires',
    cvc: 'CVC',
    mmyy: 'MM / YY',
    country: 'Billing Country',
    saveCard: 'Save Card',
    addPaymentMethod: 'Add Payment Method',
    deliveryDetails: 'Delivery Details',
    noOrderHistory: 'No Order History',
    noPaymentMethods: 'No Payment Methods',
    addPaymentMethodPrompt: 'Please add a payment method',
    noCreditCards: 'No Payment Methods',
    otherPostalCode: 'For non US or Canadian cards, please enter any number',
    membership: 'Membership',
    history: 'History',
    payments: 'Payments',
    offline: 'Pay in Person',
    orderId: 'Order ID',
    editTitle: 'Edit Personal Information',
    payment: {
      title: 'Delete Payment Method',
      body: 'Are you sure you want to delete this payment method?',
      cancel: 'Cancel',
      delete: 'Delete',
      status: {
        cvcFailed: 'Invalid CVC',
        postalCodeFailed: 'Postal Code incorrect',
        expiredCard: 'Card Expired'
      }
    },
    rewards: {
      redeemFor: 'Redeem for',
      rewardOptions: 'Reward Options',
      coupons: 'Coupons',
      punchCards: 'Punch Cards',
      using: 'Using',
      remaining: 'Remaining',
      free: 'Free',
      purchases: 'Purchases',
      redeem: 'Redeem',
      max: 'Max',
      points: 'Points',
      credits: 'Credits',
      discount: 'Discount',
      yourPoints: 'Your Points',
      creditsEarned: '{0} earned',
      worth: 'Worth',
      insufficientFunds: 'Not enough points to redeem',
      removeFirst: 'Please remove your active Reward Option',
      punchCardRibbon: 'Purchase {0} more {1} for {2}!',
      selectItem: 'Select Item',
      availableInCart: 'Available rewards are shown in cart',
      availableInCartUpdated: 'Click on your cart to redeem this reward!',
      alreadyInCart: '"{0}" is already in your cart',
      missingPoints: 'You need {0} more points to use this punch card!',
      inEligible: 'You are not Eligible for this coupon',
      noExpiration: 'No expiration',
      noLimitation: 'No limitation',
      buy1Get1Free: 'BUY 1, GET 1 FREE',
      buy1Get1PercentOff: 'BUY 1, GET 1 {0}% OFF',
      buy1Get1AmountOff: 'BUY 1, GET 1 ${0} OFF',
      validForSelectItems: 'Valid for select items',
      discountPercentOff: 'Discount {0}% Off',
      discountAmountOff: 'Discount {0}{1} Off',
      discountOff: 'Discount {0} OFF',
      discountUpTo: '{0}, up to {1}',
      maxDiscountReached: 'Maximum discount of {0} reached',
      maxDiscountOf: 'Up to {0}',
      maxDiscountOfDetail: 'Maximum discount of {0}',
      offerExpires: 'Offer expires: {0}',
      loginPrompt: 'Please login to see your rewards',
      inPersonRedeemable: 'This reward is only redeemable in store',
      orderRewards: {
        congrats: 'Congratulations!',
        coupons: 'Your order awarded you a bonus coupon',
        lossFallback: 'Sorry you have not won this time, please try again on the next order!'
      }
    }
  },
  storePage: {
    aiRecommendationsCategory: 'Recommended For You',
    aiRecommendationsCategoryGuest: 'Recommended',
    deliveryProvider: {
      robot: 'Robot',
      human: 'Courier',
      byRobot: 'Meet robot outside',
      byHuman: 'Meet courier at door',
      recommended: 'Recommended by this business',
      notSupported: '{0} delivery is not supported for your address', //where 0 is either Robot or Human
      deliveryInstructions: 'Please be aware, Robots cannot climb stairs. You will need to provide your emailed code in order to retrieve your food'
    },
    error: {
      empty: 'Nothing to show here!',
      noResults: 'returned no results.',
      tryAdjusting: 'Try adjusting your filter',
      clear: 'Clear search'
    }
  },
  order: {
    estimatedTime: 'Your order has been successfully placed, it will be ready for pickup {0}',
    estimatedTimeDiff: 'Your order has been successfully placed, it will be ready for pickup in about {0}',
    successfulOrder: 'Your order has been successfully placed',
    deliveryAddressInvalid: 'The address you have entered is invalid, please try again',
    deliveryAddressMustBeSet: 'Your delivery address must be set',
    deliveryAddressMustBeInRange: 'Sorry, your address is not in the delivery range, please contact the store to place your order',
    noPaymentMethodSelected: 'Please select a payment method',
    insufficientPoints: 'Insufficient membership balance',
    requiresAdditionalMethod: 'Insufficient balance, second payment method required',
    cardMinimumCharge: 'At least {0} must be paid by card. Add a tip or another item, or pay this order by card.',
    minCardChargeNote: 'Minimum card charge {0}',
    applyMembershipInstead: 'Apply {0} instead',
    noPaymentMethods: 'Please select a payment method',
    pickUpDetails: 'Pick Up Details',
    orderDetails: 'Order Details',
    selectOrderType: 'Select Order Type',
    orderPlaced: 'Order Placed',
    orderScheduled: 'Scheduled Time',
    orderNotes: 'Order Notes',
    pickUpTime: 'Pick Up Time',
    pickUpDay: 'Pick Up Day',
    deliveryTime: 'Delivery Time',
    deliveryDay: 'Delivery Day',
    deliveryAddress: 'Delivery Address',
    addressLine1: 'Address Line 1',
    addressLine2: 'Address Line 2',
    postalCode: 'Postal Code',
    city: 'City',
    payment: 'Payment',
    placeOrder: 'Place Order',
    personalDetails: 'Personal Details',
    tableNumberSet: 'Your table has been set.',
    onlyOffline: "This store only takes payment in person.",
    paidOffline: "Order will be paid in person",
    emailReceipt: "Email me the receipt",
    offlineEmailReceipt: "Email me the order confirmation",
    status: {
      new: 'New',
      inProgress: 'In Progress',
      ready: 'Ready',
      cancelled: 'Cancelled',
      refunded: 'Refunded',
      completed: 'Completed'
    },
    orderActions: {
      call: 'Call',
      direction: 'Directions',
      orders: 'View Orders',
      feedbackTitle: 'Consider providing feedback on your order',
      feedbackLabel: 'Provide Feedback'
    }
  },
  iosBanner: {
    partOne: 'Click the share icon',
    partTwo: 'and then select add to home screen',
    partThree: 'to install'
  },
  checkoutSuccess: {
    text: 'Checkout success'
  },
  orderSubmitted: {
    text: 'Order Submitted'
  },
  deliveryDialog: {
    title: 'Delivery Details',
    deliverAsap: 'Deliver ASAP',
    schedule: 'Schedule',
    update: 'Update',
    selectAddress: 'Please enter your address',
    noDeliveryProviders: 'No delivery providers support that address',
    deliveryAddressSet: 'Delivery address set!',
    selectDateTime: 'Please select a valid date and time',
    notAvailable: 'Sorry this is not available',
    pleaseSelectDate: 'Please select a date'
  },
  orderDialog: {
    title: 'Pick Up Detail',
    deliveryTitle: 'Delivery Detail',
    pickUpAsap: 'Pick Up ASAP',
    deliverAsap: 'Deliver ASAP',
    schedule: 'Schedule',
    done: 'Done',
    selectDate: 'Please select a date',
    notAvailable: 'Sorry this is not available',
    selectDateTime: 'Please select a valid date and time',
    noAvailableDays: "Sorry, there are no available days",
    earliestDate: "The earliest date has been set",
    staleTimeBodyGroup: "The store can't have your order ready by {0}. Pick a new time to continue — your group and guests' items won't change.",
    staleTimeBodySolo: "The store can't have your order ready by {0}. Pick a new time to continue.",
    confirmSlot: "Confirm {0}",
    goBack: "Go Back"
  },
  storeLocation: {
    pickUpAt: 'Pick Up',
    inStore: 'In store',
    pickUpTime: 'Pick Up Time',
    deliveryTime: 'Delivery Time',
    time: 'Time',
    deliverTo: 'Deliver to',
    clickToSet: 'Click to set'
  },
  orderTypes: {
    pickup: 'Pick Up',
    delivery: 'Delivery',
    dineIn: 'Dine In'
  },
  groupOrder: {
    title: 'Group Order',
    namePlaceholder: 'Group Order Name',
    from: 'From',
    deliverTo: 'Deliver To',
    pickupAt: 'Pickup At',
    invitePeople: 'Invite People',
    chooseWhoPays: 'Choose Who Pays',
    paySubtitle: 'The host (you) will be charged for the entire group order. Payment method will be entered at checkout.',
    youPayForEveryone: 'You pay for everyone',
    hostWillPayForEveryone: 'Host will pay for everyone',
    limitPlaceholder: 'Enter limit per person (optional)',
    perPerson: 'per person',
    everyonePaysThemselves: 'Everyone pays for themselves',
    comingSoon: 'COMING SOON',
    next: 'Next',
    yourGroupOrderLink: 'Your group order link',
    copy: 'Copy',
    share: 'Share',
    linkCopied: 'Link copied!',
    join: 'Join {0}\'s Group Order',
    spendingLimit: 'Spending limit',
    limitNoLimit: 'No Limit',
    limitOther: 'Other',
    joinGroupOrder: 'Join Group Order',
    joining: 'Joining...',
    loginToJoin: 'Login to Join',
    continueAsGuest: 'Continue as Guest',
    enterYourName: 'Enter your name',
    joinOrderDisclaimer: 'By clicking JOIN Order you agree to',
    joinOrder: 'JOIN Order',
    back: 'Back',
    notSet: 'Not set',
    cancelGroupOrder: 'Cancel Group Order',
    cancelGroupOrderConfirmTitle: 'Cancel {0}?',
    cancelGroupOrderConfirmBody: 'This will end the group order for everyone. All participants will be removed.',
    cancelGroupOrderConfirm: 'Yes, cancel it',
    cancelGroupOrderKeep: 'Keep group order',
    cartMenuCancelGroup: 'Cancel Group Order',
    cartMenuLeaveGroup: 'Leave',
    cartMenuInvite: 'Invite People',
    lockedBannerGuest: 'This group order has been locked. Please contact the host to make changes.',
    lockedBannerHost: 'Your cart is locked. You can still proceed to checkout.',
    unlockMyCart: 'Unlock my cart',
    othersInGroup: 'Others in your group ({0} people)',
    othersHaveAdded: '{0} of {1} have added items',
    memberHostLabel: '(Host)',
    memberReadyBadge: 'Ready',
    memberWaitingBadge: 'Waiting',
    memberErrorBadge: 'Item unavailable',
    memberCartHasErrors: 'Someone in your group has an unavailable item. Remove it to continue.',
    memberNoItems: 'No items yet',
    unlockMemberCart: "Unlock {0}'s cart",
    removeMember: 'Remove {0}',
    yourItems: 'Your Items',
    leaveConfirmTitle: 'Leave this group order?',
    leaveConfirmBody: 'Your items will be removed and the host will be notified that you left.',
    leaveConfirmBtn: 'Leave',
    leaveConfirmKeep: 'Cancel',
    removeConfirmTitle: 'Remove {0} from this group order?',
    removeConfirmBody: "{0}'s items will be removed and they'll be notified that the host removed them from the group.",
    removeConfirmBtn: 'Remove {0}',
    checkoutConfirmTitle: 'Is everyone ready?',
    checkoutConfirmBody: 'If you continue, your group order will be locked and no one will be able to make any changes.',
    unreadyConfirmTitleSingle: '{0} is still ordering',
    unreadyConfirmTitleMulti: '{0} guests are still ordering',
    unreadyConfirmBody: 'Checking out closes the order for everyone.',
    unreadyConfirmWaitingOnPrefix: 'Waiting on ',
    unreadyConfirmWaitingOnSuffix: '.',
    and: 'and',
    andOthers: 'and {0} others',
    checkoutWithCurrentBtn: 'Check out with their carts',
    checkoutWithCurrentSubtext: "Order includes whatever they've added so far",
    removeCartsCheckoutBtn: 'Check out without them',
    removeCartsCheckoutSubtext: 'Their carts and items are removed from the order',
    errorRemoveUnreadyCarts: 'Could not remove some unready carts. Please try again.',
    groupCartEmpty: 'Add at least one item before checking out.',
    participantWaiting: 'Waiting...',
    notReadyCount: '{0} participant(s) not ready yet',
    goToCheckout: 'Go to Checkout',
    lockedInGroupOrder: "You're in a group order — order type and time can't be changed.",
    checkoutProcessing: 'Processing...',
    checkoutBackBtn: 'Go Back',
    readyBtn: "I'm Ready",
    imReadyBtn: "I'm Ready",
    addItemsBtn: 'Add items',
    readyStatus: "You're ready!",
    readyHint: "The host will place the order for everyone.",
    lockedCheckoutBtn: "Group order locked",
    lockedTimeoutBtn: "Order locked — time's up",
    exceedsLimit: 'Exceeds group order limit',
    snackParticipantLeft: '{0} has left the group order.',
    errorMarkReady: 'Failed to mark cart as ready. Please try again.',
    errorCartLocked: 'The host has locked the order. You cannot make changes now.',
    errorUnlockCart: 'Could not unlock cart. Please try again.',
    errorLockGroup: 'Failed to lock group order. Please try again.',
    errorLeaveGroup: 'Failed to leave group order. Please try again.',
    errorCancelGroup: 'Failed to cancel group order. Please try again.',
    errorUnlockMember: 'Failed to unlock cart. Please try again.',
    errorRemoveParticipant: 'Failed to remove participant. Please try again.',
    dialogRemovedTitle: "You've been removed",
    dialogRemovedBody: 'The host has removed you from this group order. Your items have been cleared.',
    dialogLeftTitle: 'You left {0}',
    dialogLeftBody: 'Your items have been cleared.',
    dialogCancelledTitle: 'Group Order Cancelled',
    dialogCancelledBody: 'The host has cancelled this group order.',
    dialogPaidTitle: 'Order Placed!',
    dialogPaidBody: 'Your group order has been successfully placed.',
    dialogRecoveredTitle: 'You have an ongoing group order',
    dialogRecoveredHost: 'You are the host',
    dialogRecoveredGuest: 'You are a participant',
    dialogRecoveredBtn: 'Continue',
    deadlineTitle: 'Set a Deadline',
    deadlineSubtitle: 'When should everyone order by?',
    deadlineDayLabel: 'Order by (Day)',
    deadlineTimeLabel: 'Order by (Time)',
    noDeadline: 'No Deadline',
    noDeadlineSet: 'No deadline set',
    deadlineSpecificTime: 'Specific time',
    orderDeadline: 'Order deadline',
    orderBeforeDeadline: 'Order before {0}',
    peopleCanOrderAnytime: 'People can order at any time',
    notAvailableScheduled: 'Not available for this scheduled time',
    deadlineNotAvailableNow: 'Deadline is not available when delivery time is set to Now.',
    noAvailableDeadlineTimes: 'No available times for a deadline. Please select a later delivery time.',
    noSpendingLimit: 'No spending limit',
    spendingLimitValue: '{0} spending limit',
    dialogChangedTitle: 'Order Updated by Host',
    dialogChangedToDelivery: 'Changed to Delivery',
    dialogChangedToPickup: 'Changed to Pickup',
    dialogChangedTime: 'Time changed from {0} to {1}',
    dialogChangedTimeSet: 'Scheduled time set to {0}',
    dialogChangedTimeCleared: 'Scheduled time removed (ASAP)',
    timeChangedLabel: 'Time changed',
    timeChangedToLabel: 'Time changed to',
    confirmChangeToDelivery: 'Change to Delivery?',
    confirmChangeToPickup: 'Change to Pickup?',
    confirmChangeTypeBody: 'This will update the order type for everyone in the group.',
    asap: 'ASAP',
    orderAsap: 'Order ASAP',
    now: 'Now',
    staleTimeTitle: 'Your selected time is no longer available',
    staleTimeNearestSlotLabel: 'Nearest available',
    staleTimeChooseAnother: 'Choose another time',
    errorResetSchedule: 'Failed to update scheduled time. Please try again.',
    errorUpdateSchedule: 'Failed to update scheduled time. Please try again.',
    errorUpdateScheduleConflict: 'This couldn\'t be updated right now. Please review and try again.',
    discountsAtCheckout: 'Discounts applied at checkout',
    deliveryFeeAtCheckout: 'Calculated at checkout',
    feesCalculatedAtCheckout: 'Taxes, fees & discounts calculated at checkout',
    exceedsSpendingLimit: 'This item would exceed the spending limit set by the host.',
    cartFinalized: 'Your group order has been finalized. You cannot add more items.',
    noDeadlineSlots: 'No available time slots to set a deadline for this order.',
    errorUpdateDeadline: 'Unable to update the deadline. Please try again.',
    deadlineUpdated: 'Order deadline updated: {0}',
    deadlineRemoved: 'Order deadline updated.',
    shareGroupOrder: 'Join my group order!',
    memberLocked: 'Locked',
    snackParticipantLeftHost: '{0} has left the group order.',
    tooltipBadgeNew: 'NEW',
    tooltipTitle: 'How Group Order works',
    tooltipScene1Caption: 'Start a group order from the menu page',
    tooltipScene2Caption: 'Set a deadline — and who pays',
    tooltipScene3Caption: 'Share the link, or let friends scan to join',
    tooltipScene4Caption: 'Everyone adds to one cart. One checkout.',
    tooltipStartBtn: 'Start a Group Order',
    tooltipGotItBtn: 'Got it',
    tooltipDemoPeopleJoined: '{0} people joined',
    tooltipDemoDeadlineTimeExample: 'Fri, Jul 10 · 12:30 PM',
    tooltipDemoPaySub: 'You pay · $15 limit each',
    tooltipDemoLinkExample: 'gosnappy.io/g/tonnys-order…',
    tooltipDemoGroupCartLabel: 'Group cart',
    tooltipDemoOneCheckout: 'One checkout — you pay',
    sheetTitle: 'Group ordering is here',
    sheetSubtitle: 'Order together — one shared cart, one checkout.',
    sheetBullet1: 'Set an order deadline',
    sheetBullet2: 'You pay — or set a spending limit',
    sheetBullet3: 'Invite with a link or QR code',
    sheetNotNowBtn: 'Not now',
    showHowItWorks: 'Show me how it works',
    hostSetsTip: 'As the host, you set the tip for the whole group order.',
    checkoutErrorGeneric: 'Checkout failed. Please try again.',
    checkoutErrorInvalidCart: 'Some items in the cart need attention before you can check out.',
    checkoutErrorOutOfStock: 'Some items are no longer available. Please remove them and try again.',
    checkoutErrorMissingSelection: 'Please review the selections on a cart item.',
    checkoutErrorInvalidItem: 'An item in the cart is no longer valid. Please remove it and try again.',
    checkoutErrorPaymentDeclined: 'Your card was declined. Please try a different payment method.',
    checkoutErrorPaymentFraud: 'This payment method was declined by the card issuer. Please try a different one.',
    checkoutErrorCardDetails: 'There is a problem with the card details. Please check and try again.',
    checkoutErrorCardExpired: 'This card has expired. Please try a different payment method.',
    checkoutErrorPaymentGateway: 'We could not process the payment. Please try again.',
    checkoutErrorNotOpen: 'This group order is no longer open.',
    checkoutErrorVersionConflict: 'The group order changed while you were checking out. Please review and try again.',
    checkoutErrorInProgress: 'Checkout is already in progress.',
    checkoutErrorEmpty: 'The group cart is empty.',
    checkoutErrorBlocked: 'Some participants are not ready yet.',
  },
  weChat: {
    warning: 'Please exit the page and use WeChat Scanner to scan the QR Code',
    title: 'Enter Table Number'
  },
  checkout: {
    addCoupon: 'Add Coupon',
    couponCode: 'Coupon Code',
    title: 'Submit Order',
    description: 'Are you ready to submit your order?',
    confirmCancel: 'No',
    confirmApprove: 'Yes',
    onlinePay: 'Online Pay',
    weChatPay: 'WeChat Pay',
    unitNumber: 'Unit Number (optional)',
    primaryMethod: 'Payment',
    secondaryMethod: 'Second Payment Method',
    credits: 'Balance',
    orderHints: 'i.e. any dietary restrictions',
    deliveryHints: 'i.e. ring the bell after delivery, leave next to the porch, buzzer number, etc.',
    deliveryOptions: 'Delivery Options',
    deliveryInstructions: 'Delivery Instructions',
    orderDisposables: 'Utensils, Straws, etc.',
    deliveryDisposables: 'Disposable Utensils',
    disposablesIncluded: 'These items won\'t be included unless you ask',
    noPaymentMethods: 'No Payment options are available.<br>Please reach out to {0}',
    billLoadError: 'We couldn\'t load your order total. Please try again.',
    applePayFailed: 'Apple Pay couldn\'t be started. Please try again, or choose another payment method.',
    retry: 'Try Again',
    confirmDialog: {
      total: 'Total',
      name: 'Store Name',
      location: 'Store Location',
      deliveryInfo: 'Delivery Info',
      deliveryAddress: 'Delivery Address',
      deliveryPhone: 'Delivery Phone Number',
      scheduled: 'Scheduled For',
      pay: 'Pay',
      pickupTitle: 'Pick up at the store?',
      pickupBody: "Confirm that you'll pick up this order at the store.",
      pickupTime: 'Pickup time:',
      beforeYouArrive: 'Before you arrive',
      yesPickUp: 'Yes, Pick Up',
      goBack: 'Go Back'
    },
    deliveryMessage: {
      leave_at_door: 'Leave At Door',
      meet_at_door: 'Meet At Door',
      meet_outside: 'Meet Outside'
    },
    couponTypes: {
      title: 'Your coupon limits your payment options to:',
      membership: 'Store Wallet',
      online: 'Credit Cards',
      wechat: 'WeChat',
      offline: 'Pay In Person'
    }
  },
  qr: {
    manulInput: 'Scanner not working? Please enter your table number.',
    selectTable: 'Your Table Number',
    select: 'Confirm'
  },
  apps: {
    giftcard: 'Gift Cards',
    coupons: 'Purchase coupons',
    deposit: 'Add Funds',
    lineup: 'Waitlist',
    reservation: 'Reservations'
  },
  requestService: {
    openButton: 'Request Service',
    title: 'Make a request of your server',
    sent: 'Request sent',
    login: 'Must be logged in to use this feature',
    tableNeeded: 'Please set your table number to use this feature'
  },
  sharedCart: {
    bannerLabel: 'Shared Table · Table #{0}',
    live: 'Live',
    staleItemWarning: 'Updated by another guest — review before saving',
    sentToKitchen: 'Sent to Kitchen',
    roundSentToKitchen: 'Round {0} · Sent to Kitchen',
    alreadyOrdered: 'Already ordered',
    itemCount: '{0} items',
    stillOrdering: 'Adding now',
    sending: 'Sending...',
    reconnected: 'Reconnected to shared table {0}.',
    joinedTitle: 'You\'ve Joined the Table!',
    joinedBody: 'You\'re now sharing this table\'s order with everyone else here.',
    completedTitle: 'Table Order Paid!',
    completedBody: 'Payment for this table has been completed. Thank you!',
    billAtPosTitle: 'Bill Sent to Register',
    billAtPosBody: 'Your table\'s bill has been sent to the counter. Please pay there to complete your order.',
    cancelledTitle: 'Table Session Ended',
    cancelledBody: 'This table\'s shared cart session has expired. Please scan the QR code to start a new session.',
    roundFired: 'Items sent to the kitchen.',
    errorFireRound: 'Failed to send to kitchen. Please try again.',
    errorItemChanged: 'Someone else already changed this item — refreshed to the latest version, please try again.',
    errorMutateCart: 'That didn\'t go through. Please try again.',
    errorSessionClosed: 'This table has already been closed.',
    sharedTable: 'Shared Table',
    sharedTableActive: '● Shared Table Active',
    tableLabel: 'Table {0}',
    errorStartSharedTable: 'Unable to start shared table. Please try again.',
  },
}
